import { useLayoutStore } from '@/store/modules/layout';
export default {
  name: 'AppFooter',
  data() {
    const layoutStore = useLayoutStore();
    return {
      isRTL: layoutStore.isRTL
    };
  }
};